import mainApiClient from '../interceptor.mainApiClient';

const networkIntelligenceEndpoints = {
  buildGraph: (data, config) =>
    mainApiClient.post(`/api/v1/network-intelligence/build`, data, config),

  getAnalysis: (personId, config) =>
    mainApiClient.get(`/api/v1/network-intelligence/analysis/${personId}`, config),

  calculateAssociationRisk: (data, config) =>
    mainApiClient.post(`/api/v1/network-intelligence/association-risk`, data, config),

  getConnected: (personId, config) =>
    mainApiClient.get(`/api/v1/network-intelligence/connected/${personId}`, config),

  getVisualization: (personId, config) =>
    mainApiClient.get(`/api/v1/network-intelligence/visualization/${personId}`, config),

  getEdgeDetails: (config) =>
    mainApiClient.get(`/api/v1/network-intelligence/edge-details`, config),

  getCommunityMembers: (communityId, config) =>
    mainApiClient.get(`/api/v1/network-intelligence/community/${communityId}/members`, config),

  getPersonInfo: (personId, config) =>
    mainApiClient.get(`/api/v1/people/${personId}/info`, config),

  getPersonsByPeopleIds: (data, config) =>
    mainApiClient.post(`/api/v1/people/by-peopleids`, data, config),
};

export default networkIntelligenceEndpoints;
